import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { AbsenceForm } from "./AbsenceForm";

/**
 * VIB-1221: «Meld fravær»-dialog rundt det delte AbsenceForm-skjemaet.
 * Brukt fra Mine oppgaver (egen registrering) og FravaerTab
 * (leder/admin på vegne av ansatt). Attesterte måneder må gjenåpnes først.
 */
export function ReportAbsenceDialog({
  open,
  onOpenChange,
  userId,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  userId: string;
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-2xl">
        <DialogHeader>
          <DialogTitle>Meld fravær</DialogTitle>
        </DialogHeader>
        <AbsenceForm
          userId={userId}
          onSuccess={() => onOpenChange(false)}
          onCancel={() => onOpenChange(false)}
        />
      </DialogContent>
    </Dialog>
  );
}
